import { Component, OnInit, OnDestroy } from '@angular/core';
import {MenuService} from "../../../services/menu-service";
import { DataService } from 'src/app/services/data.service';
import { DeviceDto } from 'src/app/entities/DeviceDto';
import { Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetailDialogComponent } from 'src/app/pagecomponents/devices/device-detail-dialog/device-detail-dialog.component';
import { Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-devices-list',
  standalone: false,
  templateUrl: './devices-list.component.html',
  styleUrl: './devices-list.component.css'
})
export class DevicesListComponent implements OnInit, OnDestroy {
  isLoadingStaticData = true;
  isSavingData = false;
  loadingSub: Subscription | undefined;
  savingSub: Subscription | undefined;
  devices : DeviceDto[] = [];

  private sortField: string = '';
  private sortDirection: string = '';

  constructor(private menuService: MenuService,
              private data: DataService,
              private dialog: MatDialog,
              private breakpointObserver: BreakpointObserver) {
  }

  ngOnInit(): void {
    this.loadingSub = this.menuService.loadingStatusChanged.subscribe((status: boolean) => {
      if (this.menuService.GetActiveMenuName() == 'Lista Dispositivi') {
        if (status) {
          this.data.refreshDevices().subscribe();
          this.data.startDevicesPolling();
        }
      }
      else {
        this.data.stopDevicesPolling();
      }

    });
    this.savingSub = this.menuService.savingStatusChanged.subscribe((status: boolean) => {
      this.isSavingData =  status;
    });

    this.data.devices$.subscribe(devices => { //callback per lo stream di device
      this.devices = devices;
      if (this.menuService.GetIsLoadingInProgressScreen())
        this.menuService.StopLoadingInProgressScreen();
      this.isLoadingStaticData = false;
    });
  }

  ngOnDestroy() {
    if (this.loadingSub) {
      this.loadingSub.unsubscribe();
    }
    if (this.savingSub) {
      this.savingSub.unsubscribe();
    }

    this.data.stopDevicesPolling();
  }

  trackById(index: number, item: DeviceDto): any {
    return item.targa;
  }

  onMatSortChange(sortState: Sort) {
    this.sortField = sortState.active;
    this.sortDirection = sortState.direction;
  }

  get filteredDevices() : DeviceDto[] {
    const result = [...this.devices] //create new array so change detection on array triggers re-render
      .sort((a, b) => {
        const sortDir = this.sortDirection?.toLowerCase();
        const sortField = this.sortField as keyof DeviceDto;

        if (sortDir !== 'asc' && sortDir !== 'desc' || !sortField)
          return 0;

        const direction = sortDir === 'asc' ? -1 : 1;

        let valA = a[sortField];
        let valB = b[sortField];

        if (valA == null && valB == null) return 0;
        if (valA == null) return 1 * direction;
        if (valB == null) return -1 * direction;

        if (typeof valA === 'number' && typeof valB === 'number')
          return (valA - valB) * direction;

        return valB.toString().toLowerCase().localeCompare(valA.toString().toLowerCase()) * direction;
      });

    return result;
  }

  async onRowMouseUp(event: MouseEvent, row: any): Promise<void> {
    const selection = window.getSelection();

    // If text is selected, do not select row
    if (selection && selection.toString().length > 0) {
      return;
    }

    await this.onRowSelected(row);
  }

  async onRowSelected(row: DeviceDto) {

    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 1024px)');

    const dialogRef = this.dialog.open(DeviceDetailDialogComponent, {
      width: isSmallScreen ? '90vw' : '70vw',
      height: isSmallScreen ? '95vh' : '70vh',
      maxWidth: 'none',
      autoFocus: false,
      data: {
        device: row,
        deviceCodPerif: row.codPerif
      },
      disableClose: true // previene chiusura tramite ESC e click fuori dalla dialog (verranno gestiti a mano
                         // nel dialog per mostrare un ulteriore dialog di conferma quando ci sono pending changes)
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('afterClosed', result);
    });
  }

}
